import config from '@/config'

export default class Circle
{
    constructor()
    {

    }

    drawBg(centerX, centerY, width, height, radius)
    {
        this.context.fillStyle = 'white'
        this.context.fillRect(0, 0, width, height)

        this.context.globalCompositeOperation = 'destination-out'

        this.context.beginPath()
        this.context.arc(centerX, centerY, radius, 0, Math.PI * 2)
        this.context.fill()
        this.context.closePath()

        this.context.globalCompositeOperation = 'source-over'
    }

    drawBorders(centerX, centerY, radius, angle)
    {
        this.context.beginPath()
        this.context.arc(centerX, centerY, radius, 0, 2 * Math.PI, false)
        this.context.lineWidth = 2
        this.context.strokeStyle = '#ffe2e3'
        this.context.stroke()

        this.context.beginPath()
        this.context.arc(centerX, centerY, radius, -0.5 * Math.PI, 2 * Math.PI * angle - 0.5 * Math.PI, false)
        this.context.lineWidth = 2
        this.context.strokeStyle = config.colors.red
        this.context.stroke()
    }

    update(canvas, width, height, angle)
    {
        if (canvas === undefined)
        {
            return
        }

        if (canvas !== this.canvas)
        {
            this.init(canvas)
        }

        const centerX = width / 2
        const centerY = height / 2
        const radius = width / 2 - 2

        this.context.clearRect(0, 0, width, height)
        this.drawBg(centerX, centerY, width, height, radius)
        this.drawBorders(centerX, centerY, radius, angle)
    }

    init(canvas)
    {
        this.canvas = canvas
        this.context = canvas.getContext('2d')
    }
}
